(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-links-showcase"] && !Shopify.designMode) return;
  try {
    
  function initCaseLinksGallery(root) {
    if (!root || root.dataset.caseGalleryReady === 'true') return;
    root.dataset.caseGalleryReady = 'true';

    const source = root.querySelector('[data-case-source]');
    const grid = root.querySelector('[data-case-grid]');
    const status = root.querySelector('[data-case-status]');
    const empty = root.querySelector('[data-case-empty]');
    const countOutput = root.querySelector('[data-case-visible-count]');
    const searchInput = root.querySelector('[data-case-search]');
    const categorySelect = root.querySelector('[data-case-category-select]');
    const defaultCategory = root.dataset.defaultCategory || '未分类';
    const maxLinks = Number.parseInt(root.dataset.maxLinks || '500', 10);
    const shouldDeduplicate = root.dataset.deduplicate === 'true';
    const screenshotProvider = root.dataset.screenshotProvider || 'thumio';
    const customTemplate = root.dataset.customTemplate || '';
    const screenshotWidth = root.dataset.shotWidth || '900';
    const screenshotHeight = root.dataset.shotHeight || '560';
    const screenshotMaxAge = root.dataset.shotMaxAge || '168';
    const screenshotFallback = root.dataset.shotFallback === 'true';
    const screenshotConcurrency = Math.max(1, Number.parseInt(root.dataset.shotConcurrency || '3', 10));
    const unavailableLabel = root.dataset.unavailableLabel || '该网站限制自动预览';

    if (!source || !grid) return;

    const clone = source.cloneNode(true);
    clone.hidden = false;
    clone.querySelectorAll('a[href]').forEach((anchor) => {
      const href = anchor.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(href)) return;
      if (!/^https?:\/\//i.test(anchor.textContent.trim())) {
        anchor.textContent = `${href} ${anchor.textContent.trim()}`;
      }
    });

    const rawLines = (clone.innerText || clone.textContent || '')
      .replace(/\u00a0/g, ' ')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    const cases = [];
    const seen = new Set();
    let currentCategory = defaultCategory;

    rawLines.forEach((line) => {
      if (cases.length >= maxLinks) return;
      const matches = Array.from(line.matchAll(/https?:\/\/[^\s<>"']+/gi));

      if (matches.length === 0) {
        currentCategory = line.replace(/^[#\-–—\s]+|[:：\s]+$/g, '').trim() || defaultCategory;
        return;
      }

      matches.forEach((match, index) => {
        if (cases.length >= maxLinks) return;
        const rawUrl = match[0].replace(/[),.;，。；、】》]+$/g, '');

        let parsedUrl;
        try {
          parsedUrl = new URL(rawUrl);
        } catch (error) {
          return;
        }

        if (!/^https?:$/.test(parsedUrl.protocol)) return;
        const normalizedUrl = parsedUrl.href;
        if (shouldDeduplicate && seen.has(normalizedUrl)) return;
        seen.add(normalizedUrl);

        const nextStart = index + 1 < matches.length ? matches[index + 1].index : line.length;
        const annotation = line
          .slice(match.index + match[0].length, nextStart)
          .replace(/^[\s|｜,:：;；\-–—]+|[\s|｜,:：;；\-–—]+$/g, '')
          .trim();
        const domain = parsedUrl.hostname.replace(/^www\./i, '');

        cases.push({
          url: normalizedUrl,
          origin: parsedUrl.origin,
          domain,
          title: domain,
          category: currentCategory,
          annotation
        });
      });
    });

    const categories = Array.from(new Set(cases.map((item) => item.category)));
    categories.forEach((category) => {
      if (!categorySelect) return;
      const option = document.createElement('option');
      option.value = category;
      option.textContent = category;
      categorySelect.appendChild(option);
    });

    const screenshotSourcesFor = (url) => {
      const encoded = encodeURIComponent(url);
      const thumio = {
        type: 'thumio',
        url: `https://image.thum.io/get/width/${screenshotWidth}/crop/${screenshotHeight}/maxAge/${screenshotMaxAge}/allowJPG/noanimate/?url=${encoded}`
      };
      const mshots = {
        type: 'mshots',
        url: `https://s0.wordpress.com/mshots/v1/${encoded}?w=${screenshotWidth}&h=${screenshotHeight}`
      };

      if (screenshotProvider === 'custom' && customTemplate.includes('{url}')) {
        return [{
          type: 'custom',
          url: customTemplate
            .replaceAll('{url}', encoded)
            .replaceAll('{width}', screenshotWidth)
            .replaceAll('{height}', screenshotHeight)
        }];
      }

      if (screenshotProvider === 'none') return [];
      if (screenshotProvider === 'mshots') return screenshotFallback ? [mshots, thumio] : [mshots];
      return screenshotFallback ? [thumio, mshots] : [thumio];
    };

    const pendingImages = [];
    let activeImageRequests = 0;

    const markPreviewUnavailable = (image, reason) => {
      const media = image.closest('.case-links-gallery__media');
      if (!media) return;
      media.classList.add('is-unavailable');
      image.remove();
      const output = media.querySelector('[data-preview-status]');
      if (output) output.textContent = reason || unavailableLabel;
    };

    const showBlob = (image, blob) => new Promise((resolve, reject) => {
      const media = image.closest('.case-links-gallery__media');
      const objectUrl = URL.createObjectURL(blob);
      image.onload = () => {
        media?.classList.add('is-loaded');
        URL.revokeObjectURL(objectUrl);
        resolve();
      };
      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('image_decode_failed'));
      };
      image.src = objectUrl;
    });

    const fetchScreenshot = async (image, source) => {
      if (source.type === 'custom') {
        await new Promise((resolve, reject) => {
          const media = image.closest('.case-links-gallery__media');
          image.onload = () => {
            media?.classList.add('is-loaded');
            resolve();
          };
          image.onerror = () => reject(new Error('custom_provider_failed'));
          image.src = source.url;
        });
        return;
      }

      const response = await fetch(source.url, {
        mode: 'cors',
        credentials: 'omit',
        cache: 'force-cache'
      });

      if (!response.ok) throw new Error(`provider_${response.status}`);

      if (source.type === 'thumio') {
        const targetStatus = Number.parseInt(response.headers.get('thum_status_code') || '200', 10);
        if (targetStatus >= 400) {
          const error = new Error(`target_${targetStatus}`);
          error.targetStatus = targetStatus;
          throw error;
        }
      }

      await showBlob(image, await response.blob());
    };

    const loadQueuedImage = async (image) => {
      const sources = JSON.parse(image.dataset.sources || '[]');
      let lastError;

      for (const source of sources) {
        try {
          await fetchScreenshot(image, source);
          return;
        } catch (error) {
          lastError = error;
          if (error.targetStatus === 404 || error.targetStatus === 403 || error.targetStatus === 429) break;
        }
      }

      markPreviewUnavailable(image, unavailableLabel);
      if (lastError) image.dataset.previewError = lastError.message;
    };

    const runImageQueue = () => {
      while (activeImageRequests < screenshotConcurrency && pendingImages.length > 0) {
        const image = pendingImages.shift();
        if (!image?.isConnected) continue;
        activeImageRequests += 1;
        loadQueuedImage(image).finally(() => {
          activeImageRequests -= 1;
          runImageQueue();
        });
      }
    };

    const queueImage = (image) => {
      if (image.dataset.queued === 'true') return;
      image.dataset.queued = 'true';
      pendingImages.push(image);
      runImageQueue();
    };

    const imageObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            queueImage(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '500px 0px' })
      : null;

    const fragment = document.createDocumentFragment();

    cases.forEach((item, index) => {
      const card = document.createElement('article');
      card.className = 'case-links-gallery__card';
      card.dataset.caseCard = '';
      card.dataset.category = item.category;
      card.dataset.searchText = `${item.domain} ${item.category} ${item.annotation}`.toLocaleLowerCase();
      card.style.viewTransitionName = `case-link-card-${index + 1}`;

      const link = document.createElement('a');
      link.className = 'case-links-gallery__link';
      link.href = item.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', `查看案例：${item.domain}`);

      const media = document.createElement('div');
      media.className = 'case-links-gallery__media';

      const placeholder = document.createElement('div');
      placeholder.className = 'case-links-gallery__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');

      const initial = document.createElement('strong');
      initial.textContent = item.domain.slice(0, 1).toUpperCase();
      const favicon = document.createElement('img');
      favicon.className = 'case-links-gallery__favicon';
      favicon.src = `${item.origin}/favicon.ico`;
      favicon.alt = '';
      favicon.width = 64;
      favicon.height = 64;
      favicon.loading = 'lazy';
      favicon.referrerPolicy = 'no-referrer';
      favicon.addEventListener('load', () => {
        if (favicon.naturalWidth > 4) favicon.classList.add('is-loaded');
      }, { once: true });
      const placeholderDomain = document.createElement('span');
      placeholderDomain.textContent = item.domain;
      const previewStatus = document.createElement('small');
      previewStatus.className = 'case-links-gallery__preview-status';
      previewStatus.dataset.previewStatus = '';
      placeholder.append(initial, favicon, placeholderDomain, previewStatus);
      media.appendChild(placeholder);

      const screenshotSources = screenshotSourcesFor(item.url);
      if (screenshotSources.length > 0) {
        const image = document.createElement('img');
        image.className = 'case-links-gallery__image';
        image.alt = `${item.domain} 网站截图`;
        image.width = Number.parseInt(screenshotWidth, 10);
        image.height = Number.parseInt(screenshotHeight, 10);
        image.loading = 'lazy';
        image.referrerPolicy = 'no-referrer';
        image.dataset.sources = JSON.stringify(screenshotSources);
        media.appendChild(image);
        if (imageObserver) imageObserver.observe(image);
        else queueImage(image);
      }

      const category = document.createElement('span');
      category.className = 'case-links-gallery__category';
      category.textContent = item.category;
      media.appendChild(category);

      const overlay = document.createElement('span');
      overlay.className = 'case-links-gallery__overlay';
      overlay.setAttribute('aria-hidden', 'true');
      const visit = document.createElement('span');
      visit.className = 'case-links-gallery__visit';
      visit.textContent = '查看网站 ↗';
      overlay.appendChild(visit);
      media.appendChild(overlay);

      const info = document.createElement('div');
      info.className = 'case-links-gallery__info';
      const title = document.createElement('h2');
      title.className = 'case-links-gallery__title';
      title.textContent = item.title;
      const urlText = document.createElement('p');
      urlText.className = 'case-links-gallery__url';
      urlText.textContent = item.url;
      info.append(title, urlText);

      if (item.annotation) {
        const annotation = document.createElement('p');
        annotation.className = 'case-links-gallery__annotation';
        annotation.textContent = item.annotation;
        info.appendChild(annotation);
      }

      link.append(media, info);
      card.appendChild(link);
      fragment.appendChild(card);
    });

    grid.appendChild(fragment);
    status.hidden = true;

    const updateResults = () => {
      const query = (searchInput?.value || '').trim().toLocaleLowerCase();
      const selectedCategory = categorySelect?.value || 'all';
      let visible = 0;

      grid.querySelectorAll('[data-case-card]').forEach((card) => {
        const matchesSearch = !query || card.dataset.searchText.includes(query);
        const matchesCategory = selectedCategory === 'all' || card.dataset.category === selectedCategory;
        const show = matchesSearch && matchesCategory;
        card.hidden = !show;
        if (show) visible += 1;
      });

      countOutput.textContent = visible;
      empty.hidden = visible !== 0;
    };

    searchInput?.addEventListener('input', updateResults);
    categorySelect?.addEventListener('change', updateResults);
    updateResults();
  }

  document.querySelectorAll('[data-case-gallery]').forEach(initCaseLinksGallery);

  document.addEventListener('shopify:section:load', (event) => {
    initCaseLinksGallery(event.target.querySelector('[data-case-gallery]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-parallax-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    const controllers = new Map();
    let threePromise;

    function loadThree() {
      if (window.THREE) return Promise.resolve(window.THREE);
      if (threePromise) return threePromise;

      threePromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-ipg-three]');

        if (existing) {
          existing.addEventListener('load', () => resolve(window.THREE), { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = THREE_URL;
        script.async = true;
        script.dataset.ipgThree = 'true';
        script.addEventListener('load', () => resolve(window.THREE), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return threePromise;
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function readBoolean(value) {
      return value === 'true';
    }

    class InfiniteParallaxGallery {
      constructor(root, THREE) {
        this.root = root;
        this.THREE = THREE;
        this.stage = root.querySelector('[data-ipg-stage]');
        this.loading = root.querySelector('[data-ipg-loading]');
        this.empty = root.querySelector('[data-ipg-empty]');
        this.loadingBase = this.loading ? this.loading.textContent.trim() : '';
        this.sectionId = root.dataset.sectionId;

        this.layerCount = clamp(Number(root.dataset.layerCount) || 5, 2, 5);
        this.imagesPerLayer = clamp(Number(root.dataset.imagesPerLayer) || 10, 3, 16);
        const configuredSpeed = clamp(Number(root.dataset.baseSpeed) || 60, 5, 240);
        const speedMultiplier = clamp(Number(root.dataset.speedMultiplier) || 1.8, 1, 3);
        this.baseSpeed = configuredSpeed * speedMultiplier;
        this.imageSize = clamp(Number(root.dataset.imageSize) || 160, 60, 360);
        this.direction = root.dataset.direction === 'left' ? -1 : 1;
        this.enableDrag = readBoolean(root.dataset.enableDrag);
        this.enableWheel = readBoolean(root.dataset.enableWheel);
        this.pauseOnHover = readBoolean(root.dataset.pauseOnHover);
        this.respectReducedMotion = readBoolean(root.dataset.respectReducedMotion);
        this.pixelRatio = clamp(Number(root.dataset.pixelRatio) || 2, 1, 2);

        this.layerScale = [1.5, 1, 0.8, 0.6, 0.5];
        this.layerSpeed = [1, 0.5, 0.375, 0.25, 0.1875];
        // 所有视差层保持 100% 不透明，避免图片与深色背景混合后变暗。
        // 层级感继续通过尺寸和移动速度体现，不再牺牲图片原始亮度与颜色。
        this.layerOpacity = [1, 1, 1, 1, 1];

        this.layers = [];
        this.textures = [];
        this.materials = [];
        this.rafId = null;
        this.lastTime = 0;
        this.dragging = false;
        this.lastPointerX = 0;
        this.motionFactor = this.direction;
        this.dragVelocity = 0;
        this.hoverPaused = false;
        this.destroyed = false;
        this.isVisible = true;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.animate = this.animate.bind(this);

        this.imageUrls = Array.from(root.querySelectorAll('[data-ipg-image]'))
          .map((element) => element.dataset.src)
          .filter(Boolean);
      }

      async init() {
        if (!this.stage || this.imageUrls.length === 0) {
          this.showEmpty();
          return;
        }

        this.scene = new this.THREE.Scene();
        this.renderer = new this.THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
          powerPreference: 'high-performance'
        });

        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, this.pixelRatio));
        this.renderer.setClearColor(0x000000, 0);

        // 正确输出到浏览器的 sRGB 色彩空间。
        // Three.js r128 使用 outputEncoding；同时兼容新版 Three.js 的 outputColorSpace。
        if ('outputColorSpace' in this.renderer && this.THREE.SRGBColorSpace) {
          this.renderer.outputColorSpace = this.THREE.SRGBColorSpace;
        } else if ('outputEncoding' in this.renderer && this.THREE.sRGBEncoding) {
          this.renderer.outputEncoding = this.THREE.sRGBEncoding;
        }

        // 禁用色调映射，防止渲染器额外压暗高光或改变图片颜色。
        if (this.THREE.NoToneMapping !== undefined) {
          this.renderer.toneMapping = this.THREE.NoToneMapping;
        }

        this.stage.prepend(this.renderer.domElement);

        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this.stage);

        this.bindEvents();
        this.resize(false);

        try {
          await this.loadTextures();
          if (this.destroyed) return;
          this.buildSprites();
          this.loading.hidden = true;
          this.lastTime = performance.now();

          if (this.shouldReduceMotion()) {
            this.render();
          } else {
            this.rafId = requestAnimationFrame(this.animate);
          }
        } catch (error) {
          console.error('Infinite parallax gallery failed to initialize.', error);
          this.showEmpty();
        }
      }

      shouldReduceMotion() {
        return this.respectReducedMotion && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      showEmpty() {
        if (this.loading) this.loading.hidden = true;
        if (this.empty) this.empty.hidden = false;
      }

      bindEvents() {
        if (this.enableDrag) {
          this.stage.addEventListener('pointerdown', this.onPointerDown);
          this.stage.addEventListener('pointermove', this.onPointerMove);
          this.stage.addEventListener('pointerup', this.onPointerUp);
          this.stage.addEventListener('pointercancel', this.onPointerUp);
        }

        if (this.enableWheel) {
          this.stage.addEventListener('wheel', this.onWheel, { passive: false });
        }

        if (this.pauseOnHover) {
          this.stage.addEventListener('pointerenter', this.onPointerEnter);
          this.stage.addEventListener('pointerleave', this.onPointerLeave);
        }
      }

      unbindEvents() {
        this.stage.removeEventListener('pointerdown', this.onPointerDown);
        this.stage.removeEventListener('pointermove', this.onPointerMove);
        this.stage.removeEventListener('pointerup', this.onPointerUp);
        this.stage.removeEventListener('pointercancel', this.onPointerUp);
        this.stage.removeEventListener('wheel', this.onWheel);
        this.stage.removeEventListener('pointerenter', this.onPointerEnter);
        this.stage.removeEventListener('pointerleave', this.onPointerLeave);
      }

      onPointerDown(event) {
        if (event.target.closest('a, button, input, textarea, select, summary')) return;
        this.dragging = true;
        this.lastPointerX = event.clientX;
        this.dragVelocity = 0;
        this.stage.classList.add('is-dragging');
        this.stage.setPointerCapture(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const deltaX = event.clientX - this.lastPointerX;
        this.lastPointerX = event.clientX;
        this.dragVelocity = clamp(deltaX * 0.08, -4, 4);
        this.motionFactor = this.dragVelocity || this.motionFactor;
      }

      onPointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.stage.classList.remove('is-dragging');

        if (this.stage.hasPointerCapture(event.pointerId)) {
          this.stage.releasePointerCapture(event.pointerId);
        }
      }

      onWheel(event) {
        event.preventDefault();
        const wheelDirection = Math.sign(event.deltaY) || 1;
        const nextSpeed = Math.abs(this.motionFactor) + 0.6;
        this.motionFactor = wheelDirection * clamp(nextSpeed, 0.5, 5);
        this.dragVelocity = this.motionFactor;
      }

      onPointerEnter() {
        this.hoverPaused = true;
      }

      onPointerLeave() {
        this.hoverPaused = false;
      }

      async loadTextures() {
        const loader = new this.THREE.TextureLoader();
        loader.crossOrigin = 'anonymous';
        let completed = 0;

        const tasks = this.imageUrls.map((url) => new Promise((resolve) => {
          loader.load(
            url,
            (texture) => {
              // 将 Shopify 图片按 sRGB 纹理读取，保持与普通 <img> 标签一致的颜色表现。
              if ('colorSpace' in texture && this.THREE.SRGBColorSpace) {
                texture.colorSpace = this.THREE.SRGBColorSpace;
              } else if (this.THREE.sRGBEncoding) {
                texture.encoding = this.THREE.sRGBEncoding;
              }
              texture.needsUpdate = true;
              completed += 1;
              this.updateLoading(completed, this.imageUrls.length);
              resolve(texture);
            },
            undefined,
            () => {
              completed += 1;
              this.updateLoading(completed, this.imageUrls.length);
              resolve(this.createFallbackTexture());
            }
          );
        }));

        this.textures = await Promise.all(tasks);
      }

      updateLoading(loaded, total) {
        if (!this.loading) return;
        const percentage = Math.round((loaded / total) * 100);
        this.loading.textContent = this.loadingBase ? `${this.loadingBase} ${percentage}%` : `${percentage}%`;
      }

      createFallbackTexture() {
        const canvas = document.createElement('canvas');
        canvas.width = 320;
        canvas.height = 320;
        const context = canvas.getContext('2d');
        const gradient = context.createLinearGradient(0, 0, 320, 320);
        gradient.addColorStop(0, '#4a4a4a');
        gradient.addColorStop(1, '#171717');
        context.fillStyle = gradient;
        context.fillRect(0, 0, 320, 320);
        return new this.THREE.CanvasTexture(canvas);
      }

      resize(rebuild = true) {
        if (!this.renderer || !this.stage) return;
        const width = Math.max(1, this.stage.clientWidth);
        const height = Math.max(1, this.stage.clientHeight);

        this.renderer.setSize(width, height, false);

        if (!this.camera) {
          this.camera = new this.THREE.OrthographicCamera(0, width, height, 0, -1000, 1000);
          this.camera.position.z = 10;
        } else {
          this.camera.right = width;
          this.camera.top = height;
          this.camera.updateProjectionMatrix();
        }

        if (rebuild && this.textures.length > 0) {
          this.buildSprites();
          this.render();
        }
      }

      clearSprites() {
        this.layers.forEach((layer) => {
          layer.forEach((sprite) => {
            this.scene.remove(sprite);
            sprite.material.dispose();
          });
        });
        this.layers = [];
        this.materials = [];
      }

      buildSprites() {
        this.clearSprites();
        const width = this.stage.clientWidth;
        const height = this.stage.clientHeight;

        for (let layerIndex = 0; layerIndex < this.layerCount; layerIndex += 1) {
          const scale = this.layerScale[layerIndex];
          const approximateWidth = Math.max(80, this.imageSize * scale * 0.7);
          const spriteCount = clamp(
            Math.max(this.imagesPerLayer, Math.ceil(width / approximateWidth) + 4),
            this.imagesPerLayer,
            24
          );
          const layer = [];
          let cursorX = -width * 0.2;

          for (let index = 0; index < spriteCount; index += 1) {
            const texture = this.textures[Math.floor(Math.random() * this.textures.length)];
            const image = texture.image || {};
            const ratio = image.width && image.height ? image.width / image.height : 1;
            const sizeVariation = this.random(0.84, 1.16);
            let spriteWidth = this.imageSize * scale * sizeVariation;
            let spriteHeight = spriteWidth;

            if (ratio > 1) {
              spriteHeight = spriteWidth / ratio;
            } else {
              spriteHeight = spriteWidth / Math.max(ratio, 0.01);
              if (spriteHeight > this.imageSize * scale * 1.35) {
                spriteHeight = this.imageSize * scale * 1.35;
                spriteWidth = spriteHeight * ratio;
              }
            }

            const material = new this.THREE.SpriteMaterial({
              map: texture,
              transparent: true,
              opacity: this.layerOpacity[layerIndex],
              depthTest: false,
              depthWrite: false,
              toneMapped: false
            });
            const sprite = new this.THREE.Sprite(material);
            const spacing = spriteWidth * this.random(0.45, 0.9);
            cursorX += spriteWidth / 2 + spacing;
            const minY = spriteHeight / 2;
            const maxY = Math.max(minY, height - spriteHeight / 2);
            const baseY = this.random(minY, maxY);

            sprite.scale.set(spriteWidth, spriteHeight, 1);
            sprite.position.set(cursorX, baseY, -layerIndex * 50);
            sprite.userData = {
              width: spriteWidth,
              height: spriteHeight,
              baseY,
              speed: this.baseSpeed * this.layerSpeed[layerIndex] * this.random(0.55, 1.15),
              seed: this.random(0, 1000),
              opacity: this.layerOpacity[layerIndex]
            };

            cursorX += spriteWidth / 2;
            layer.push(sprite);
            this.materials.push(material);
            this.scene.add(sprite);
          }

          this.distributeLayer(layer, width);
          this.layers.push(layer);
        }
      }

      distributeLayer(layer, width) {
        if (layer.length === 0) return;
        const totalWidth = layer.reduce((sum, sprite) => sum + sprite.userData.width, 0);
        const gap = Math.max(12, (width + width * 0.4 - totalWidth) / layer.length);
        let cursor = -width * 0.2;

        layer.forEach((sprite) => {
          cursor += sprite.userData.width / 2 + gap;
          sprite.position.x = cursor;
          cursor += sprite.userData.width / 2;
        });
      }

      random(min, max) {
        return Math.random() * (max - min) + min;
      }

      animate(now) {
        if (this.destroyed) return;
        const delta = Math.min(40, now - this.lastTime) / 1000;
        this.lastTime = now;

        if (!document.hidden && this.isVisible && !this.hoverPaused) {
          if (!this.dragging) {
            this.dragVelocity *= 0.93;
            if (Math.abs(this.dragVelocity) > 0.02) {
              this.motionFactor = this.dragVelocity;
            } else {
              const target = this.direction;
              this.motionFactor += (target - this.motionFactor) * 0.018;
            }
          }

          const width = this.stage.clientWidth;
          const time = now * 0.001;

          this.layers.forEach((layer) => {
            layer.forEach((sprite) => {
              const data = sprite.userData;
              sprite.position.x += data.speed * this.motionFactor * delta;

              if (this.motionFactor >= 0 && sprite.position.x - data.width / 2 > width) {
                sprite.position.x = -data.width / 2 - this.random(0, data.width * 0.7);
              } else if (this.motionFactor < 0 && sprite.position.x + data.width / 2 < 0) {
                sprite.position.x = width + data.width / 2 + this.random(0, data.width * 0.7);
              }

              const pulse = 1 + Math.sin(time + data.seed) * 0.015;
              sprite.scale.set(data.width * pulse, data.height * pulse, 1);
              sprite.position.y = data.baseY + Math.sin(time + data.seed) * 5;
              sprite.material.opacity = data.opacity;
            });
          });

          this.render();
        }

        this.rafId = requestAnimationFrame(this.animate);
      }

      render() {
        if (this.renderer && this.scene && this.camera) {
          this.renderer.render(this.scene, this.camera);
        }
      }

      setVisible(isVisible) {
        this.isVisible = isVisible;
        if (isVisible) this.lastTime = performance.now();
      }

      destroy() {
        this.destroyed = true;
        if (this.rafId) cancelAnimationFrame(this.rafId);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.unbindEvents();
        this.clearSprites();

        this.textures.forEach((texture) => texture.dispose());
        this.textures = [];

        if (this.renderer) {
          this.renderer.dispose();
          this.renderer.forceContextLoss();
          this.renderer.domElement.remove();
        }
      }
    }

    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionId = entry.target.dataset.sectionId;
        const controller = controllers.get(sectionId);
        if (controller) controller.setVisible(entry.isIntersecting);
      });
    }, { rootMargin: '200px 0px' });

    async function initialize(root) {
      if (!root || root.dataset.ipgInitialized === 'true') return;
      root.dataset.ipgInitialized = 'true';

      const sectionId = root.dataset.sectionId;
      const existingController = controllers.get(sectionId);
      if (existingController && existingController.root !== root) destroyById(sectionId);

      const hasImages = Array.from(root.querySelectorAll('[data-ipg-image]'))
        .some((element) => Boolean(element.dataset.src));

      if (!hasImages) {
        const loading = root.querySelector('[data-ipg-loading]');
        const empty = root.querySelector('[data-ipg-empty]');
        if (loading) loading.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }

      try {
        const THREE = await loadThree();
        if (!document.documentElement.contains(root)) return;
        const controller = new InfiniteParallaxGallery(root, THREE);
        controllers.set(root.dataset.sectionId, controller);
        visibilityObserver.observe(root);
        await controller.init();
      } catch (error) {
        root.dataset.ipgInitialized = 'false';
        const loading = root.querySelector('[data-ipg-loading]');
        const empty = root.querySelector('[data-ipg-empty]');
        if (loading) loading.hidden = true;
        if (empty) empty.hidden = false;
        console.error('Three.js could not be loaded for the infinite parallax gallery.', error);
      }
    }

    function initializeAll(scope = document) {
      if (scope.matches && scope.matches('[data-ipg-root]')) initialize(scope);
      scope.querySelectorAll('[data-ipg-root]').forEach(initialize);
    }

    function destroyById(sectionId) {
      const controller = controllers.get(sectionId);
      if (!controller) return;
      visibilityObserver.unobserve(controller.root);
      controller.destroy();
      controllers.delete(sectionId);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyById(event.detail.sectionId);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
